import styled, { DefaultTheme } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { AdStatus } from '@/types';

function getBg(status: AdStatus, theme: DefaultTheme) {
  switch (status) {
    case AdStatus.Pending: {
      return theme.palette.system.yellow;
    }
    case AdStatus.AwaitingPayment:
    case AdStatus.Expired:
    case AdStatus.Archived: {
      return theme.palette.tertiary.labels;
    }
    case AdStatus.Rejected: {
      return theme.palette.system.red;
    }
    default: {
      return 'transparent';
    }
  }
}

export const Box = styled(Typography.Body)<{ $status: AdStatus }>`
  color: ${({ theme }) => theme.palette.system.white};
  background-color: ${({ theme, $status }) => getBg($status, theme)};
  padding: 15px;
  display: grid;
  gap: 15px;

  span {
    white-space: break-spaces;
  }

  ul {
    display: grid;
    gap: 10px;
    padding-left: 15px;
    margin-top: 20px;
  }
`;

export const SingleRejectReason = styled(Typography.Caption)`
  margin-top: 16px;
  font-size: 16px;
  color: inherit;
`;

export const StatusText = styled(Typography.Text)`
  font-size: 16px;
`;
